export * from './BatchWriter';
export * from './PhaseTimer';
export * from './callerTool';
export * from './makeAppInstance';
export * from './makeModuleInstance';
export * from './promise';
export * from './warningBanner';

const Formatter = new Intl.NumberFormat();

export const formatNumber = (number: number | undefined, formatter = Formatter) =>
  number ? formatter.format(number) : number;

export function parseFiniteInt<T extends number | string>(value: string, fallback: T): number | T {
  const parsed = parseInt(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function pluralize(input: string, count: number) {
  return input + (count > 1 ? 's' : '');
}

let rand = 0;

export function randomId() {
  return String(Math.floor(Math.random() * 100_000)) + rand++;
}
